module.exports = __webpack_public_path__ + "static/img/sp-bg.f1453d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/customisation/sp-bg.png
// module id = i157
// module chunks = 1